/**
 * cd-product-reviews-lightbox.js
 *
 * Click any customer photo in `.cd-product-reviews` → opens a
 * full-screen lightbox modal with the high-res image, prev/next
 * navigation through the rest of that card's photos, close on
 * Esc / backdrop click / X button.
 *
 * Uses event delegation on the section root, so it handles both
 * the SSR'd photos and any photos added later by the Load More
 * fetcher without rebinding.
 *
 * Native <dialog> for the modal — gives Esc-to-close, focus trap,
 * and inert background for free.
 */

(function () {
  if (window.__cdProductReviewsLightbox) return;
  window.__cdProductReviewsLightbox = true;

  var dialog = null;
  var img = null;
  var prevBtn = null;
  var nextBtn = null;
  var counter = null;
  var current = { urls: [], index: 0 };

  function ensureDialog() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'cd-pdp-lightbox';
    dialog.innerHTML =
      '<button type="button" class="cd-pdp-lightbox__close" aria-label="Close" data-cd-lb-close>'
      + '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">'
      + '<path d="M5 5L15 15M15 5L5 15" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/>'
      + '</svg></button>'
      + '<button type="button" class="cd-pdp-lightbox__nav cd-pdp-lightbox__nav--prev" aria-label="Previous photo" data-cd-lb-prev>'
      + '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">'
      + '<path d="M12 4L6 10L12 16" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>'
      + '</svg></button>'
      + '<img class="cd-pdp-lightbox__img" alt="" />'
      + '<button type="button" class="cd-pdp-lightbox__nav cd-pdp-lightbox__nav--next" aria-label="Next photo" data-cd-lb-next>'
      + '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">'
      + '<path d="M8 4L14 10L8 16" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>'
      + '</svg></button>'
      + '<div class="cd-pdp-lightbox__counter" data-cd-lb-counter></div>';
    document.body.appendChild(dialog);

    img = dialog.querySelector('.cd-pdp-lightbox__img');
    prevBtn = dialog.querySelector('[data-cd-lb-prev]');
    nextBtn = dialog.querySelector('[data-cd-lb-next]');
    counter = dialog.querySelector('[data-cd-lb-counter]');

    dialog.querySelector('[data-cd-lb-close]').addEventListener('click', close);
    prevBtn.addEventListener('click', function () { step(-1); });
    nextBtn.addEventListener('click', function () { step(1); });

    // Backdrop click closes (native <dialog> ::backdrop covers area
    // outside the dialog content; click on the dialog element itself
    // when the click is on its surface, not children, means backdrop).
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) close();
    });

    // Native `close` event fires for ALL close paths — Esc key,
    // dialog.close() calls, form-method=dialog submits. Hooking
    // here (instead of only inside our close() function) ensures
    // the body scroll lock always lifts, no matter how the dialog
    // was dismissed.
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('cd-pdp-lightbox-open');
    });

    document.addEventListener('keydown', function (e) {
      if (!dialog.open) return;
      if (e.key === 'ArrowLeft') step(-1);
      else if (e.key === 'ArrowRight') step(1);
      // Esc is handled natively by <dialog>
    });
  }

  function open(urls, index) {
    ensureDialog();
    current.urls = urls;
    current.index = index;
    render();
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    document.documentElement.classList.add('cd-pdp-lightbox-open');
  }

  function close() {
    if (!dialog) return;
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      // Polyfill path: <dialog> close event won't fire, so lift the
      // scroll lock manually here.
      document.documentElement.classList.remove('cd-pdp-lightbox-open');
    }
  }

  function step(delta) {
    if (!current.urls.length) return;
    current.index = (current.index + delta + current.urls.length) % current.urls.length;
    render();
  }

  function render() {
    if (!current.urls.length) return;
    img.src = current.urls[current.index];
    img.alt = 'Customer photo ' + (current.index + 1) + ' of ' + current.urls.length;
    var hasMany = current.urls.length > 1;
    prevBtn.hidden = !hasMany;
    nextBtn.hidden = !hasMany;
    counter.hidden = !hasMany;
    if (hasMany) {
      counter.textContent = (current.index + 1) + ' / ' + current.urls.length;
    }
  }

  function delegateClick(e) {
    var link = e.target.closest('.cd-product-reviews__pic');
    if (!link) return;
    var card = link.closest('.cd-product-reviews__card');
    if (!card) return;
    e.preventDefault();

    // Collect all photos in this card (use href which is the high-res URL).
    var picLinks = card.querySelectorAll('.cd-product-reviews__pic');
    var urls = [];
    var startIndex = 0;
    for (var i = 0; i < picLinks.length; i++) {
      var href = picLinks[i].getAttribute('href');
      if (href) urls.push(href);
      if (picLinks[i] === link) startIndex = urls.length - 1;
    }
    if (!urls.length) return;
    open(urls, startIndex);
  }

  function init() {
    var sections = document.querySelectorAll('.cd-product-reviews');
    for (var i = 0; i < sections.length; i++) {
      sections[i].addEventListener('click', delegateClick);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
